import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReportTag } from '../models/reportTag';

@Injectable({
  providedIn: 'root'
})
export class ReportTaggingService {

  constructor(private http: HttpClient, private toast: ToastrService) { }

  public LoadReportTags() : Observable<ReportTag[]> {
    return this.http.get<ReportTag[]>(environment.baseURl + `/api/reportTag/load`)
  }
  removeReportTag(tagId: number, screeningId: number): Observable<any> {
    return this.http.get(environment.baseURl + `/api/reporttag/${tagId}/${screeningId}`);
  }
}
